import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'
import { injectExternalList, injectExternalReducer } from 'helpers/actions'
import moment from 'helpers/moment'

export const ProcessRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'process(/:date)',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/ProcessContainer').default

      const date = moment(nextState.params.date, { castAsTimezone: true }).format()
      injectExternalList(store, 'pricelist', date)
      injectExternalList(store, 'orders', date)
      injectExternalList(store, 'options')
      injectExternalList(store, 'uoms')
      injectExternalList(store, 'customers')

      cb(null, Container)
    }, 'orders')
  }
})

let baseOrderRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'orders(/:date)',
  routeIntention: 'form',
  authentication: true,
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/OrdersContainer').default

      const reducer = require('./modules/order').default
      const date = moment(nextState.params.date, { castAsTimezone: true }).format()

      injectReducer(store, { key: 'order', reducer })
      injectExternalList(store, 'orders', date)
      injectExternalList(store, 'pricelist', date)
      injectExternalList(store, 'customers')
      injectExternalList(store, 'options')
      injectExternalList(store, 'uoms')

      injectExternalReducer(store, 'auth')
      injectExternalReducer(store, 'staging')

      cb(null, Container)
    }, 'orders')
  }
})

export const OrdersListRoute = (store) => Object.assign({}, baseOrderRoute(store), {
  path: 'orders(/:date)/list',
  routeIntention: 'list'
})

export const NewOrderRoute = (store) => Object.assign({}, baseOrderRoute(store), {
  path: 'orders(/:date)/new',
  routeIntention: 'form'
})

export const OrdersRoute = (store) => Object.assign({}, baseOrderRoute(store), {
  path: 'orders(/:date)'
})

export const EditOrderRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'orders/:id/edit',
  authentication: true,
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditOrderContainer').default

      const actions = require('./modules/order').actions
      const reducer = require('./modules/order').default

      injectReducer(store, { key: 'order', reducer })
      injectExternalList(store, 'customers')
      injectExternalList(store, 'options')
      injectExternalList(store, 'uoms')

      injectExternalReducer(store, 'auth')
      injectExternalReducer(store, 'staging')

      store.dispatch(actions.get(nextState.params.id)).then(action => {
        const date = moment(action.payload && action.payload.date, { castAsTimezone: true }).format()
        injectExternalList(store, 'orders', date)
        injectExternalList(store, 'pricelist', date)
      })
      .then(() => cb(null, Container))
    }, 'orders')
  }
})

export default function (store) {
  return [
    ProcessRoute(store),

    EditOrderRoute(store),
    OrdersListRoute(store),
    NewOrderRoute(store),

    OrdersRoute(store) // should go after OrdersList and NewOrder as it's less-specific
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Orders/index.js